








































































































import { isAlfa, isNullOrUndefined } from '@/functions';
import { IDefaultTypes } from '@/interfaces';
import { ICompany } from '@/interfaces/company.interface';
import { http } from '@/services';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AddCompanyDialog extends Vue {
  @Prop()
  protected selectedCompany?: ICompany;
  protected newCompany: ICompany = {
    name: '',
    legalName: '',
    cnpj: '',
    stateRegistration: '',
    companyTypeId: 0,
  };
  protected companyTypes: Array<IDefaultTypes> = [ { id: 0, description: 'Selecione o tipo da empresa...' } ];
  protected isValid: boolean = false;
  protected rules = {
    name: [
      (name: string) =>
        (name.trim().length >= 3 && name.trim().length < 120) ||
        'O nome de fantasia é requerido!',
    ],
    legalName: [
      (legalName: string) =>
        (
          (isNullOrUndefined(legalName) || legalName.trim().length === 0) ||
          (legalName.trim().length >= 3 && legalName.trim().length < 120)
        ) ||
        'O nome empresarial deve ter no mínimo 3 e no máximo 120 caracteres.',
    ],
    // TODO Criar função de validação do CNPJ
    cnpj: [
      (cnpj: string) =>
        (cnpj.trim().match(/^[0-9]+$/) && cnpj.trim().length === 14) ||
        'Por favor, insira um CNPJ válido',
    ],
    stateRegistration: [
      (stateRegistration: string) =>
        (
          isNullOrUndefined(stateRegistration) ||
          stateRegistration === '' ||
          stateRegistration.trim().length <= 15
        ) ||
        'A inscrição estadual deve possuir no máximo 15 caracteres.',
      (stateRegistration: string) =>
        (
          isNullOrUndefined(stateRegistration) ||
          stateRegistration === '' ||
          !!stateRegistration.trim().match(/^[0-9]+$/)
        ) ||
        'A inscrição estadual deve conter apenas dígitos.',
    ],
    companyTypeId: [
      (companyTypeId: number) =>
        companyTypeId !== 0 ||
        'Por favor, selecione o tipo da empresa.',
    ],
  };
  protected isShowing: boolean = false;

  protected async mounted(): Promise<void> {
    if (!isNullOrUndefined(this.selectedCompany)) {
      this.newCompany.id = this.selectedCompany.id;
      this.newCompany.name = this.selectedCompany.name;
      this.newCompany.legalName = this.selectedCompany.legalName;
      this.newCompany.cnpj = this.selectedCompany.cnpj;
      this.newCompany.stateRegistration = this.selectedCompany.stateRegistration;
      this.newCompany.companyTypeId = this.selectedCompany.companyTypeId;
    }

    http.get('/auxiliary/company-types')
      .then((results) => this.companyTypes.push(...results.data))
      .catch((error) => console.log(error));
  }

  protected get activatorText(): string {
    return (isNullOrUndefined(this.selectedCompany) ? 'Adicionar' : 'Editar');
  }

  @Emit('newCompany')
  protected async save(): Promise<boolean> {
    if (!isNullOrUndefined(this.selectedCompany)) {
      await http.put('/companies', {
        company: {
          id: this.selectedCompany.id,
          companyTypeId: this.newCompany.companyTypeId,
          name: this.newCompany.name,
          legalName: this.newCompany.legalName,
          cnpj: this.newCompany.cnpj,
          stateRegistration: this.newCompany.stateRegistration,
        },
      });
      this.isShowing = false;
      return true;
    } else {
      const juridicalPerson = await http.post('/person/juridical', {
        name: this.newCompany.name,
        legalName: this.newCompany.legalName,
        cnpj: this.newCompany.cnpj,
        stateRegistration: this.newCompany.stateRegistration,
      });
      await http.post('/companies', {
        userId: this.$store.state.authentication.userId,
        juridicalPersonId: juridicalPerson.data.person,
        companyTypeId: this.newCompany.companyTypeId,
      });
      this.isShowing = false;
      this.newCompany = {
        name: '',
        legalName: '',
        cnpj: '',
        stateRegistration: '',
        companyTypeId: 0,
      };
      return true;
    }
  }
}
